"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiChargeConfirmDto = void 0;
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
/**
 * Запрос на подтверждение начисления (подтверждение
 * оказания услуги, передачи товара и т.д.)
 */
class BillingApiChargeConfirmDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: `Дата, до которой средства будут заморожены. 
    Ранее этой даты поставщик не сможет вывести средства на внешний счёт или карту.`,
  type: String,
  format: "date-time",
  nullable: true
}), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Object)], BillingApiChargeConfirmDto.prototype, "holdUntil", void 0);
exports.BillingApiChargeConfirmDto = BillingApiChargeConfirmDto;
